import { readTextFile } from '../utils/readJson.js'
import { createAndAddGenericElement, createCenteredUnderlinedText } from './generics.js'

const createServiceHeader = (serviceBlockObj, parentDiv) => {
    let serviceHeaderDiv = parentDiv
    let headerWrapper = serviceBlockObj
    if(serviceBlockObj.headerWrapper) {
        serviceHeaderDiv = createAndAddGenericElement(serviceBlockObj.headerWrapper.classList, "", "", "", serviceBlockObj.headerWrapper.element)
        headerWrapper = serviceBlockObj.headerWrapper
    }
    createAndAddGenericElement(headerWrapper.header.classList, "", serviceHeaderDiv, headerWrapper.header.text, headerWrapper.header.element)
    if (serviceHeaderDiv !== parentDiv) parentDiv.appendChild(serviceHeaderDiv)
}

const createServiceIcon = (serviceBlockObj, parentDiv) => {
    let serviceIconDiv = parentDiv
    let iconWrapper = serviceBlockObj
    if(serviceBlockObj.iconWrapper) {
        serviceIconDiv = createAndAddGenericElement(serviceBlockObj.iconWrapper.classList, "", "", "", serviceBlockObj.iconWrapper.element)
        iconWrapper = serviceBlockObj.iconWrapper
    }
    createAndAddGenericElement(iconWrapper.icon.classList, "", serviceIconDiv, "", iconWrapper.icon.element)
    if (serviceIconDiv !== parentDiv) parentDiv.appendChild(serviceIconDiv)
}

const createServicePara = (serviceBlockObj, parentDiv) => {
    let serviceParaDiv = parentDiv
    let paraWrapper = serviceBlockObj
    if(serviceBlockObj.paraWrapper) {
        serviceParaDiv = createAndAddGenericElement(serviceBlockObj.iconWrapper.classList, "", "", "", serviceBlockObj.iconWrapper.element)
        paraWrapper = serviceBlockObj.paraWrapper
    }
    createAndAddGenericElement(paraWrapper.para.classList, "", serviceParaDiv, paraWrapper.para.text, paraWrapper.para.element)
    if (serviceParaDiv !== parentDiv) parentDiv.appendChild(serviceParaDiv)
}

const createServiceContainer = (featureObj, parentDiv) => {
    if (!featureObj && !parentDiv) return
    const serviceBlockContainerDiv = createAndAddGenericElement(["service-block-container"], "", "", "", "div")
    const serviceBlockDiv = createAndAddGenericElement(featureObj.serviceBlock.classList, "", "", "", featureObj.serviceBlock.element)
    createServiceHeader(featureObj.serviceBlock, serviceBlockDiv)
    createServiceIcon(featureObj.serviceBlock, serviceBlockDiv)
    createServicePara(featureObj.serviceBlock, serviceBlockDiv)
    serviceBlockContainerDiv.appendChild(serviceBlockDiv)
    parentDiv.appendChild(serviceBlockContainerDiv)
}

const createFeaturesDivFromJSON = (sectionFeatureId, featuresJson) => {
    readTextFile(featuresJson, function(readFeaturesContent) {
        const featuresData = JSON.parse(readFeaturesContent)
        const containerDiv = createAndAddGenericElement(["container", "client"], "", "", "", "div")
        createCenteredUnderlinedText("Features", "h2", containerDiv)
        const rowDiv = createAndAddGenericElement(["row", "justify-content-center"], "", "", "", "div")
        const numServiceCards = featuresData.featureList.length
        for(let i = 0; i < numServiceCards; ++i) {
            createServiceContainer(featuresData.featureList[i], rowDiv)
        }
        containerDiv.appendChild(rowDiv)
        sectionFeatureId.appendChild(containerDiv)
    })
}

export { createFeaturesDivFromJSON }